import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectSystemState } from './system.selectors';
import { selectBlockState } from './block.selectors';

export const selectEventsListComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.EventsListComponent
);

export const selectSystemCurrentEventBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectEventsListComponent,
  (systemState, eventsListComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = eventsListComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.currentEvent?.events ? instanceBlock[selectedSystem]?.currentEvent?.events  : null;
  }
);

export const selectSystemCurrentEventStatusBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectEventsListComponent,
  (systemState, eventsListComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = eventsListComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.currentEvent?.state;
  }
);

export const selectSystemEventsHistoryBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectEventsListComponent,
  (systemState, eventsListComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = eventsListComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.eventsHistory?.events ? instanceBlock[selectedSystem]?.eventsHistory?.events : null;
  }
);

export const selectSystemEventsHistoryStatusBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectEventsListComponent,
  (systemState, eventsListComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = eventsListComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.eventsHistory?.state;
  }
);